import { $, $$ } from '../../../shared/js/utils/dom';
import {
  currentBreakpoint,
  isMobile,
} from '../../../shared/js/globals/breakpoints';
import {
  headerHeight,
  headerHeightFixed,
} from '../../../shared/js/globals/header';
import { Shower } from '../../../shared/js/modules/shower';
import Bus from '../../../shared/js/modules/event-bus';
import { initRedirects } from '../../_accessibility/focus-redirect';

const header = $('.header');

// Main Nav
const indicateOpenNavMain = () => {
  header.classList.add('header--nav-main-open');
};

const indicateClosedNavMain = () => {
  header.classList.remove('header--nav-main-open');
};

// Sticky Header
const stickyHeaderHandler = () => {
  const breakpoint = currentBreakpoint;
  const windowPosTop = window.pageYOffset;
  const targetHeaderHeight = headerHeight[breakpoint];
  const targetHeaderHeightFixed = headerHeightFixed[breakpoint];

  if (windowPosTop >= targetHeaderHeight - targetHeaderHeightFixed) {
    header.classList.add('header--is-fixed');
    document.body.style.paddingTop = `${targetHeaderHeight}px`;
  }

  if (windowPosTop < targetHeaderHeight - targetHeaderHeightFixed) {
    header.classList.remove('header--is-fixed');
    document.body.style.paddingTop = '';
  }
};

// Mobile Burger Menu
const mobileMainNavToggle = $('.header__nav-main-burger');
const mobileMainNav = $('.header__nav-main-burger-content');
let mobileMainNavShowerInstance;

const setupBurgerMenuShower = () => {
  if (!mobileMainNavToggle) return;
  mobileMainNavToggle.removeEventListener('keydown', onKeydown);
  mobileMainNav.removeEventListener('keydown', onKeydown);
  mobileMainNavShowerInstance?.destroy();

  // IF mobile header
  if (isMobile) {
    mobileMainNavShowerInstance = new Shower({
      target: mobileMainNav,
      handler: mobileMainNavToggle,
      duration: 300,
      initOpened: false,
      openClassName: 'is-open',
      toggleStart: (_, state) => {
        if (state === 'show') {
          indicateOpenNavMain();
          Bus.broadcast('navmain_open', null);
        }
      },
      toggleEnd: (_, state) => {
        if (state !== 'show') {
          indicateOpenNavMain();
          Bus.broadcast('navmain_close', null);
        }
      },
    });

    mobileMainNavShowerInstance.init();
    header.classList.add('header--is-reduced');
    mobileMainNavToggle.addEventListener('keydown', onKeydown);
    mobileMainNav.addEventListener('keydown', onKeydown);
    return;
  }

  header.classList.remove('header--is-reduced');
};

// Focus Handling

const accessibilityNavMetaLinks = $$('.header__accessibility .nav-meta__link');
const accessibilityNavMetaFirstLink = accessibilityNavMetaLinks[0];
const accessibilityNavMetaLastLink =
  accessibilityNavMetaLinks[accessibilityNavMetaLinks.length - 1];
const socialmediaNavMetaLinks = $$('.header__socialmedia .nav-meta__link');
const socialmediaNavMetaFirstLink = socialmediaNavMetaLinks[0];
const socialmediaNavMetaLastLink =
  socialmediaNavMetaLinks[socialmediaNavMetaLinks.length - 1];
const metaMainNavMetaLinks = $$('.header__meta-main .nav-meta__link');
const metaMainNavMetaLinksSecondLink = metaMainNavMetaLinks[1];
const metaMainNavMetaLinksLastLink =
  metaMainNavMetaLinks[metaMainNavMetaLinks.length - 1];

const headerFocusHandler = () => {
  const mobileMainNavToggleConfig =
    "{ 'smartphone': {'next': { 'selector': '.nav-main__link' }, 'previous': { 'selector': '.header__socialmedia .nav-meta__item:last-child .nav-meta__link' } }, 'tablet': {'next': { 'selector': '.nav-main__link' }, 'previous': { 'selector': '.header__meta-main .nav-meta__item:last-child .nav-meta__link' } }, 'desktop': {} }";
  const accessibilityNavMetaFirstLinkConfig =
    "{ 'smartphone': { 'previous': { 'selectLastElement': true, 'selector': '.nav-main [aria-hidden=`false`] .nav-main__link, .nav-main__item[data-level=`1`] > .nav-main__expand-toggle' } }, 'desktop': {} }";
  const accessibilityNavMetaLastLinkConfig =
    "{ 'smartphone': { 'next': { 'selector': '.header__meta-main .nav-meta__item:not(.nav-meta__item--search) .nav-meta__link' } }, 'tablet': {} }";
  const socialmediaNavMetaFirstLinkConfig =
    "{ 'smartphone': { 'previous': { 'selector': '.header__meta-main .nav-meta__item:last-child .nav-meta__link' } }, 'tablet': {} }";
  const socialmediaNavMetaLastLinkConfig =
    "{'smartphone': { 'next': { 'selector': '.header__nav-main-burger' } }, 'tablet': {} }";
  const metaMainNavMetaLinksSecondLinkConfig =
    "{ 'smartphone': { 'previous': { 'selector': '.header__accessibility .nav-meta__item:last-child .nav-meta__link' } }, 'tablet': {} }";
  const metaMainNavMetaLinksLastLinkConfig =
    "{ 'smartphone': { 'next': { 'selector': '.header__socialmedia .nav-meta__link' } }, 'tablet': { 'next': { 'selector': '.header__nav-main-burger' } }, 'desktop': {} }";

  mobileMainNavToggle?.setAttribute(
    'data-focus-redirect',
    mobileMainNavToggleConfig
  );

  accessibilityNavMetaFirstLink?.setAttribute(
    'data-focus-redirect',
    accessibilityNavMetaFirstLinkConfig
  );

  accessibilityNavMetaLastLink?.setAttribute(
    'data-focus-redirect',
    accessibilityNavMetaLastLinkConfig
  );

  socialmediaNavMetaFirstLink?.setAttribute(
    'data-focus-redirect',
    socialmediaNavMetaFirstLinkConfig
  );

  socialmediaNavMetaLastLink?.setAttribute(
    'data-focus-redirect',
    socialmediaNavMetaLastLinkConfig
  );

  metaMainNavMetaLinksSecondLink?.setAttribute(
    'data-focus-redirect',
    metaMainNavMetaLinksSecondLinkConfig
  );

  metaMainNavMetaLinksLastLink?.setAttribute(
    'data-focus-redirect',
    metaMainNavMetaLinksLastLinkConfig
  );

  initRedirects([
    mobileMainNavToggle,
    accessibilityNavMetaFirstLink,
    accessibilityNavMetaLastLink,
    socialmediaNavMetaFirstLink,
    socialmediaNavMetaLastLink,
    metaMainNavMetaLinksSecondLink,
    metaMainNavMetaLinksLastLink,
  ]);
};

// Event handler

const onResize = () => {
  stickyHeaderHandler();
  setupBurgerMenuShower();
};

const onScroll = () => {
  stickyHeaderHandler();
};

const onKeydown = e => {
  if (e.key === 'Escape') {
    mobileMainNavShowerInstance.close();
    mobileMainNavToggle.focus();
  }
};

// Initialize header
const init = () => {
  if (!header) return;
  setupBurgerMenuShower();
  headerFocusHandler();
  Bus.subscribe('resize', 'HeaderResize', onResize);
  Bus.subscribe('scroll', 'HeaderScroll', onScroll);
  Bus.subscribe('navmain_open', 'HeaderNavMainOpen', indicateOpenNavMain);
  Bus.subscribe('navmain_close', 'HeaderNavMainClose', indicateClosedNavMain);
};

init();
